<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_679_2433)">
                        <path d="M13.0687 8.84155C12.5487 6.8132 10.7286 5.30493 8.54439 5.30493C6.36022 5.30493 4.54008 6.8132 4.02004 8.84155C3.91603 9.25763 4.22806 9.6737 4.69609 9.6737H12.4447C12.8607 9.6737 13.1727 9.25763 13.0687 8.84155Z" fill="#265D91"/>
                        <path d="M8.54232 4.26475C9.71988 4.26475 10.6745 3.31005 10.6745 2.13238C10.6745 0.954697 9.71988 0 8.54232 0C7.36476 0 6.41016 0.954697 6.41016 2.13238C6.41016 3.31005 7.36476 4.26475 8.54232 4.26475Z" fill="#265D91"/>
                        <path d="M28.9828 8.84155C28.4628 6.8132 26.6426 5.30493 24.4584 5.30493C22.2743 5.30493 20.4021 6.8132 19.9341 8.84155C19.8301 9.25763 20.1421 9.6737 20.6102 9.6737H28.3587C28.7228 9.6737 29.0868 9.25763 28.9828 8.84155Z" fill="#265D91"/>
                        <path d="M24.4564 4.26475C25.6339 4.26475 26.5885 3.31005 26.5885 2.13238C26.5885 0.954697 25.6339 0 24.4564 0C23.2788 0 22.3242 0.954697 22.3242 2.13238C22.3242 3.31005 23.2788 4.26475 24.4564 4.26475Z" fill="#265D91"/>
                        <path d="M16.5024 18.8794C13.4342 18.8794 10.886 20.9598 10.2099 23.8203C10.0539 24.3924 10.5219 24.9645 11.146 24.9645H21.9108C22.5349 24.9645 22.9509 24.3924 22.8469 23.8203C22.1188 20.9598 19.5706 18.8794 16.5024 18.8794Z" fill="#265D91"/>
                        <path d="M16.5033 17.4231C18.1404 17.4231 19.4675 16.0958 19.4675 14.4585C19.4675 12.8213 18.1404 11.494 16.5033 11.494C14.8662 11.494 13.5391 12.8213 13.5391 14.4585C13.5391 16.0958 14.8662 17.4231 16.5033 17.4231Z" fill="#265D91"/>
                        <path d="M10.83 20.0236C10.986 19.6075 10.778 19.1914 10.362 19.0354C9.06188 18.5673 8.0218 17.6312 7.39776 16.3829C6.77371 15.1347 6.7217 13.7305 7.13774 12.4302C7.29375 12.0142 7.08573 11.5981 6.6697 11.4421C6.25367 11.286 5.83764 11.4941 5.68163 11.9101C4.48553 15.4468 6.35768 19.2434 9.84194 20.4917C9.94595 20.5437 10.518 20.7517 10.83 20.0236Z" fill="#265D91"/>
                        <path d="M26.3273 11.4421C25.9112 11.5981 25.7032 12.0142 25.8592 12.4302C26.3273 13.7305 26.2233 15.1347 25.5992 16.3829C24.9752 17.6312 23.9351 18.5673 22.635 19.0354C22.219 19.1914 21.9589 19.6075 22.167 20.0236C22.479 20.7517 23.051 20.5437 23.155 20.4917C26.6913 19.2955 28.5114 15.4468 27.3154 11.9101C27.1593 11.5461 26.7433 11.286 26.3273 11.4421Z" fill="#265D91"/>
                        <path d="M12.5995 4.52485C13.6396 3.48467 14.9917 2.91257 16.4998 2.91257C17.9559 2.91257 19.3601 3.48467 20.4001 4.52485C20.5561 4.68088 21.0762 4.94093 21.4922 4.52485C21.8042 4.2128 21.8042 3.74472 21.4922 3.43266C20.1401 2.08042 18.372 1.35229 16.4998 1.35229C14.6277 1.35229 12.8596 2.08042 11.5075 3.43266C11.1954 3.74472 11.1954 4.2128 11.5075 4.52485C11.8195 4.83691 12.2875 4.83691 12.5995 4.52485Z" fill="#265D91"/>
                        </g>
                        <defs>
                        <filter id="filter0_d_679_2433" x="0" y="0" width="33" height="32.9645" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2433"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2433" result="shape"/>
                        </filter>
                        </defs>
                        </svg>
                        
                        Utilisateurs
                </h1>

                <!--begin::Menu-->
              
            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Utilisateurs</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Liste Utilisateurs</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->
        
          <div class="card-body tools">
           <div class="title mb-15">
            <h4>Liste des Utilisateurs </h4>
           </div>
          <div class="container">
            <div class="row mb-3">
                <div class="col-lg-3">
                    <div class="input-shadow mb-3">
                       <input type="text" name="search" id="search" class="form-control mb-3" placeholder="Rechercher">
                    </div>
                </div>
                <div class="col-lg-3 ">
                      
                          </div> 
                          <div class="col-lg-3 ">
                      
                          </div> 
                <div class="col-lg-3 rechercher">
                    <div class="btn_search">
                        <a href="#" class="search"> + Ajouter</a>
                       </div>     
                   
                </div>
               
            </div>
         
            <div class="table-responsive mt-15">
                <table class="table align-middle fs-6 gy-5 style-table" id="list_cra">
                    <thead>
                        <th class="bg1 min-w-125px">
                            Nom Utilisateur
                        </th>
                        <th class="bg2 min-w-125px">
                            roles
                        </th>
                        <th class="bg3 min-w-125px">
                            Email
                        </th>
                        <th class="bg4 min-w-125px">
                            Action
                        </th>
                    </thead>
                 <tbody>
                    <tr>
                        <td><span>Mohamed amine chouri</span></td>
                    <td>
                        <span> RH </span>
                    </td>
                    <td>
                        <span>aminechouri1997@gmail.com </span>
                    </td>
                    <td>
                      <div class="btns">
                        <a href="#" class="voir">Voir plus</a>
                        <a href="#" class="edit"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_679_2459)">
                            <path d="M4 18.2651V6.52326C4 5.83123 4.27658 5.16755 4.76891 4.67821C5.26123 4.18887 5.92897 3.91396 6.62522 3.91396H14.6518L12.0693 6.52326H6.62522V18.2651H18.4387V12.8574L21.0639 10.2905V18.2651C21.0639 18.9572 20.7873 19.6209 20.295 20.1102C19.8027 20.5995 19.1349 20.8744 18.4387 20.8744H6.62522C5.92897 20.8744 5.26123 20.5995 4.76891 20.1102C4.27658 19.6209 4 18.9572 4 18.2651ZM23.0328 0C22.5108 0.000456764 22.0103 0.206938 21.6415 0.574047L12.3121 9.9969C12.025 10.287 11.8084 10.6384 11.6788 11.0243L10.7337 13.8456C10.7219 13.8907 10.7221 13.9381 10.7344 13.9831C10.7467 14.0281 10.7707 14.0691 10.8038 14.1021C10.837 14.135 10.8782 14.1588 10.9235 14.171C10.9688 14.1833 11.0164 14.1835 11.0618 14.1718L13.9102 13.2422C14.2985 13.1135 14.6521 12.8982 14.9439 12.6127L24.4242 3.33991C24.6992 3.06623 24.8864 2.71768 24.9623 2.33829C25.0381 1.9589 24.9991 1.56569 24.8502 1.20831C24.7013 0.850929 24.4492 0.545417 24.1258 0.330358C23.8023 0.115299 23.422 0.000340221 23.0328 0Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_679_2459" x="0" y="0" width="29" height="28.8744" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2459"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2459" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            </a>
                      </div>
                    </td>
                    </tr>
                    <tr>
                        <td><span>Lassaad ben rjab</span></td>
                    <td>
                        <span> Consultant </span>
                    </td>
                    <td>
                        <span>aminechouri1997@gmail.com </span>
                    </td>
                    <td>
                      <div class="btns">
                        <a href="#" class="voir">Voir plus</a>
                        <a href="#" class="edit"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_679_2459)">
                            <path d="M4 18.2651V6.52326C4 5.83123 4.27658 5.16755 4.76891 4.67821C5.26123 4.18887 5.92897 3.91396 6.62522 3.91396H14.6518L12.0693 6.52326H6.62522V18.2651H18.4387V12.8574L21.0639 10.2905V18.2651C21.0639 18.9572 20.7873 19.6209 20.295 20.1102C19.8027 20.5995 19.1349 20.8744 18.4387 20.8744H6.62522C5.92897 20.8744 5.26123 20.5995 4.76891 20.1102C4.27658 19.6209 4 18.9572 4 18.2651ZM23.0328 0C22.5108 0.000456764 22.0103 0.206938 21.6415 0.574047L12.3121 9.9969C12.025 10.287 11.8084 10.6384 11.6788 11.0243L10.7337 13.8456C10.7219 13.8907 10.7221 13.9381 10.7344 13.9831C10.7467 14.0281 10.7707 14.0691 10.8038 14.1021C10.837 14.135 10.8782 14.1588 10.9235 14.171C10.9688 14.1833 11.0164 14.1835 11.0618 14.1718L13.9102 13.2422C14.2985 13.1135 14.6521 12.8982 14.9439 12.6127L24.4242 3.33991C24.6992 3.06623 24.8864 2.71768 24.9623 2.33829C25.0381 1.9589 24.9991 1.56569 24.8502 1.20831C24.7013 0.850929 24.4492 0.545417 24.1258 0.330358C23.8023 0.115299 23.422 0.000340221 23.0328 0Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_679_2459" x="0" y="0" width="29" height="28.8744" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2459"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2459" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            </a>
                      </div>
                    </td>
                    </tr>
                    <tr>
                        <td><span>Houssem ankoud</span></td>
                    <td>
                        <span> Admin </span>
                    </td>
                    <td>
                        <span>aminechouri1997@gmail.com </span>
                    </td>
                    <td>
                      <div class="btns">
                        <a href="#" class="voir">Voir plus</a>
                        <a href="#" class="edit"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_679_2459)">
                            <path d="M4 18.2651V6.52326C4 5.83123 4.27658 5.16755 4.76891 4.67821C5.26123 4.18887 5.92897 3.91396 6.62522 3.91396H14.6518L12.0693 6.52326H6.62522V18.2651H18.4387V12.8574L21.0639 10.2905V18.2651C21.0639 18.9572 20.7873 19.6209 20.295 20.1102C19.8027 20.5995 19.1349 20.8744 18.4387 20.8744H6.62522C5.92897 20.8744 5.26123 20.5995 4.76891 20.1102C4.27658 19.6209 4 18.9572 4 18.2651ZM23.0328 0C22.5108 0.000456764 22.0103 0.206938 21.6415 0.574047L12.3121 9.9969C12.025 10.287 11.8084 10.6384 11.6788 11.0243L10.7337 13.8456C10.7219 13.8907 10.7221 13.9381 10.7344 13.9831C10.7467 14.0281 10.7707 14.0691 10.8038 14.1021C10.837 14.135 10.8782 14.1588 10.9235 14.171C10.9688 14.1833 11.0164 14.1835 11.0618 14.1718L13.9102 13.2422C14.2985 13.1135 14.6521 12.8982 14.9439 12.6127L24.4242 3.33991C24.6992 3.06623 24.8864 2.71768 24.9623 2.33829C25.0381 1.9589 24.9991 1.56569 24.8502 1.20831C24.7013 0.850929 24.4492 0.545417 24.1258 0.330358C23.8023 0.115299 23.422 0.000340221 23.0328 0Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_679_2459" x="0" y="0" width="29" height="28.8744" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2459"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2459" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            </a>
                      </div>
                    </td>
                    </tr>
                    <tr>
                        <td><span>Arij gaied</span></td>
                    <td>
                        <span> Commercial </span>
                    </td>
                    <td>
                        <span>arijgaied@gmail.com </span>
                    </td>
                    <td>
                      <div class="btns">
                        <a href="#" class="voir">Voir plus</a>
                        <a href="#" class="edit"><svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_679_2459)">
                            <path d="M4 18.2651V6.52326C4 5.83123 4.27658 5.16755 4.76891 4.67821C5.26123 4.18887 5.92897 3.91396 6.62522 3.91396H14.6518L12.0693 6.52326H6.62522V18.2651H18.4387V12.8574L21.0639 10.2905V18.2651C21.0639 18.9572 20.7873 19.6209 20.295 20.1102C19.8027 20.5995 19.1349 20.8744 18.4387 20.8744H6.62522C5.92897 20.8744 5.26123 20.5995 4.76891 20.1102C4.27658 19.6209 4 18.9572 4 18.2651ZM23.0328 0C22.5108 0.000456764 22.0103 0.206938 21.6415 0.574047L12.3121 9.9969C12.025 10.287 11.8084 10.6384 11.6788 11.0243L10.7337 13.8456C10.7219 13.8907 10.7221 13.9381 10.7344 13.9831C10.7467 14.0281 10.7707 14.0691 10.8038 14.1021C10.837 14.135 10.8782 14.1588 10.9235 14.171C10.9688 14.1833 11.0164 14.1835 11.0618 14.1718L13.9102 13.2422C14.2985 13.1135 14.6521 12.8982 14.9439 12.6127L24.4242 3.33991C24.6992 3.06623 24.8864 2.71768 24.9623 2.33829C25.0381 1.9589 24.9991 1.56569 24.8502 1.20831C24.7013 0.850929 24.4492 0.545417 24.1258 0.330358C23.8023 0.115299 23.422 0.000340221 23.0328 0Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_679_2459" x="0" y="0" width="29" height="28.8744" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2459"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2459" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            </a>
                      </div>
                    </td>
                    </tr>
                 
                 
                 </tbody>
    
                </table>
             </div>
          
          
          </div>
        
           
          </div>
        </div>
     
    </div>
    <!--end::Content container-->
</div>

